var _path, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFeatured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2862 22.3568L31.6612 27.2105L33.3749 34.4693C33.4695 34.8633 33.4451 35.2765 33.305 35.6568C33.1648 36.037 32.9151 36.3671 32.5873 36.6055C32.2596 36.8438 31.8686 36.9797 31.4637 36.996C31.0588 37.0122 30.6582 36.9081 30.3124 36.6968L23.9999 32.8118L17.6837 36.6968C17.338 36.9069 16.9378 37.01 16.5336 36.9932C16.1294 36.9763 15.7392 36.8402 15.4122 36.6021C15.0851 36.3639 14.8359 36.0343 14.6958 35.6548C14.5557 35.2753 14.5311 34.8628 14.6249 34.4693L16.3449 27.2105L10.7199 22.3568C10.414 22.0924 10.1928 21.7438 10.0839 21.3545C9.97497 20.9651 9.98316 20.5523 10.1074 20.1676C10.2317 19.7829 10.4666 19.4433 10.7827 19.1913C11.0988 18.9393 11.4822 18.786 11.8849 18.7505L19.2599 18.1555L22.1049 11.2705C22.2589 10.8953 22.521 10.5743 22.8579 10.3485C23.1948 10.1226 23.5912 10.002 23.9968 10.002C24.4024 10.002 24.7988 10.1226 25.1357 10.3485C25.4726 10.5743 25.7347 10.8953 25.8887 11.2705L28.7324 18.1555L36.1074 18.7505C36.511 18.7847 36.8954 18.9371 37.2127 19.1888C37.53 19.4405 37.7659 19.7802 37.891 20.1653C38.016 20.5505 38.0246 20.964 37.9157 21.3541C37.8068 21.7441 37.5852 22.0934 37.2787 22.358L37.2862 22.3568Z",
    fill: "#ff6600"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33.1562,
    y1: 14.5944,
    x2: 36.5944,
    y2: 11.8438,
    stroke: "#ff6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 36.2127,
    y1: 29.2724,
    x2: 42.2724,
    y2: 30.7873,
    stroke: "#ff6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14.5858,
    y1: 14,
    x2: 7,
    y2: 6.41421,
    stroke: "#ff6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.88345,
    y1: 29.8957,
    x2: 10.8957,
    y2: 29.1165,
    stroke: "#ff6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 47,
    x2: 24,
    y2: 38,
    stroke: "#ff6600",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFeatured);
export default __webpack_public_path__ + "static/media/star-featured.aca1ffe0bd61bf035a2103e260ef387d.svg";
export { ForwardRef as ReactComponent };